import styled from 'styled-components'

export const StyledDocumentWrapper = styled.div`
  max-width: 960px;
  width: 100%;
  @media screen and (max-width: 1920px) {
    max-width: 800px;
    margin: 0 auto;
  }
`;

export const StyledDocumentTitle = styled.h1`
  padding: 30px 0;
  color: #162954;
  font-size: ${({size}) => size}px;
  font-weight: 600;
  text-align: center;
  @media screen and (max-width: 576px) {
    padding: 20px 0;
    font-size: 16px;
  }
`;

export const StyledDocumentText = styled.p`
  margin-bottom: 25px;
  font-size: ${({size}) => size}px;
  line-height: 30px;
  @media screen and (max-width: 576px) {
    margin-bottom: 15px;
    font-size: 14px;
    line-height: 26px;
  }
`;

export const StyledDocumentSubTitle = styled.h3`
  padding: 20px 0;
  font-size: ${({size}) => size}px;
  font-weight: 700;
   @media screen and (max-width: 576px) {
    font-size: 14px;
  }
`;

export const StyledDocumentList = styled.ul`
  margin-bottom: 25px;
  padding-left: ${({as}) => as === 'ol' ? '20px' : '0'};
  font-size: ${({size}) => size}px;
  line-height: 30px;
  list-style: ${({as}) => as === 'ol' ? 'decimal' : 'none'};
  @media screen and (max-width: 576px) {
    margin-bottom: 15px;
    font-size: 14px;
    line-height: 26px;
  }
  li {
    margin-bottom: 20px;
    padding-left: ${({as}) => as === 'ol' ? '10px' : '30px'};
    position: relative;
    &:before {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #277661;
      display: ${({as}) => as === 'ol' ? 'none' : 'block'};
      position: absolute;
      top: 8px;
      left: 7px;
    }
  }
`;